import { Moon, Sun, Sunset } from 'lucide-react'
import { useTheme } from '../hooks/useTheme'

type Props = {
  className?: string
  size?: 'sm' | 'md'
  showLabel?: boolean
}

export function ThemeToggle({ className, size = 'md', showLabel = true }: Props) {
  const { resolved, toggle } = useTheme()
  const iconSize = size === 'sm' ? 'h-4 w-4' : 'h-4.5 w-4.5'
  const label =
    resolved === 'dark' ? 'Tryb ciemny' : resolved === 'sunset' ? 'Zachód słońca' : 'Tryb jasny'
  const nextLabel = 'Zmień motyw'

  return (
    <button
      type="button"
      onClick={toggle}
      className={[
        size === 'sm'
          ? 'inline-flex h-9 items-center justify-center gap-2 pds-tag px-3 text-xs font-extrabold text-ink transition hover:bg-ink/[0.03] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/60'
          : 'inline-flex h-10 items-center justify-center gap-2 pds-tag px-4 text-sm font-extrabold text-ink transition hover:-translate-y-0.5 hover:bg-ink/[0.03] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/60',
        className ?? '',
      ].join(' ')}
      aria-label={nextLabel}
      title={label}
    >
      {resolved === 'dark' ? (
        <Sun className={iconSize} aria-hidden />
      ) : resolved === 'sunset' ? (
        <Sunset className={iconSize} aria-hidden />
      ) : (
        <Moon className={iconSize} aria-hidden />
      )}
      {showLabel ? <span className="hidden sm:inline">{label}</span> : null}
    </button>
  )
}

